<template>
  <v-card elevation="0" class="mt-4">
    <v-card-text class="pb-2">
      <h4>{{ $t('routes.labels.labels') }} ({{ labels.length }})</h4>
    </v-card-text>
    <v-card-text v-if="labels.length > 0" class="pt-0">
      <v-chip v-for="label in labels" :key="label.id" class="ma-2" size="large" style="line-break: anywhere; white-space: normal;">
        {{ label.content }}

        <CreateUpdateLabelDialog :label="label" :activeCategoryId="activeCategoryId" @labelUpdated="refreshLabels">
          <v-btn
              v-if="$canControlTenantConfig()"
              rounded="circle"
              width="36px"
              height="36px"
              variant="text"
              icon="mdi-pencil"
              class="ml-2 mr-0"
              elevation="0"
              data-cy="tenantLabels-options-createUpdateCategory"
          />
        </CreateUpdateLabelDialog>

        <DeleteLabelDialog :label="label" @labelUpdated="refreshLabels">
          <v-btn
              v-if="$canControlTenantConfig()"
              rounded="circle"
              width="36px"
              height="36px"
              variant="text"
              icon="mdi-delete"
              class="mr-0"
              elevation="0"
              data-cy="tenantLabels-options-createUpdateCategory"
          />
        </DeleteLabelDialog>
      </v-chip>
    </v-card-text>
    <v-card-text v-else>
      <div class="font-italic">
        {{ $t('routes.labels.noLabels') }}
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { useAuthStore } from '@/stores/AuthStore.js'
import { useLabelStore } from '@/stores/LabelStore.js'
import CreateUpdateLabelDialog from '@/routes/console/labels/components/dialogs/CreateUpdateLabelDialog.vue';
import DeleteLabelDialog from '@/routes/console/labels/components/dialogs/DeleteLabelDialog.vue';

export default {
  name: "LabelListView",
  components: {
    CreateUpdateLabelDialog,
    DeleteLabelDialog
  },
  data: function () {
    return {

    };
  },
  watch: {
    activeCategoryId: function(newVal, oldVal) {
      console.log('newVal', newVal);
      if (newVal === '' || newVal === null || newVal === undefined) {
        this.resetLabels();
      } else if (newVal !== oldVal) {
        this.refreshLabels(newVal);
      }
    },
  },
  methods: {
    refreshLabels: function(selectedCategoryId) {
      if (this.activeCategoryId === selectedCategoryId) {
        const payload = {
          categoryId: selectedCategoryId,
          accessPointId: this.accessPointId,
        };

        const labelStore = useLabelStore();
        labelStore.refreshLabels(payload)
          .catch((error) => {
            console.error('Error fetching data', error);
          });
      }
    },
    resetLabels: function() {
      const labelStore = useLabelStore();
      labelStore.resetLabels();
    },
  },
  computed: {
    accessPointId() {
      const authStore = useAuthStore();
      return authStore.rootNodeId;
    },
    labels() {
      const labelStore = useLabelStore();
      return labelStore.getLabels || [];
    },
    activeCategoryId() {
      const labelStore = useLabelStore();
      return labelStore.getActiveCategoryId;
    },
  },
}
</script>
